'use client';
import ImageIphone from '@/assets/images/category-second-level/card/image-xiaomi-14.png';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import { Link } from '@/i18n/navigation';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import Image from 'next/image';
import { SetStateAction, useEffect, useRef, useState } from 'react';
import { useWindowSize } from 'react-use';
import styles from './card-carousel.module.scss';
import './splide.css';

type Props = {
  images?:
    | { __typename: 'ProductMedia'; id: string; alt: string; url: string }[]
    | null
    | undefined;
  id?: string;
  slug?: string;
  categorySlug?: string;
  productId: string;
};

const splideData = [
  {
    id: 1,
    image: ImageIphone,
  },
  {
    id: 2,
    image: ImageIphone,
  },
  {
    id: 3,
    image: ImageIphone,
  },
  {
    id: 4,
    image: ImageIphone,
  },
];

const CustomCardCarousel = ({
  images,
  id,
  slug,
  categorySlug,
  productId,
}: Props) => {
  const splideRef = useRef<any>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const splide = splideRef.current?.splide;
  const { width } = useWindowSize();

  useEffect(() => {
    // Add event listener to update the current slide index when slides change
    const splide = splideRef.current?.splide;
    if (splide) {
      splide.on('moved', (newIndex: SetStateAction<number>) => {
        setCurrentSlide(newIndex);
      });
    }

    return () => {
      if (splide) {
        splide.off('moved');
      }
    };
  }, []);

  return (
    <div className={styles.carousel}>
      <Splide
        ref={splideRef}
        options={{
          updateOnMove: true,
          type: 'loop',
          perPage: 1,
          perMove: 1,
          rewind: true,
          gap: '5px',
          rewindByDrag: true,
          arrows: false,
          pagination: false,
          breakpoints: {
            1200: {
              perPage: 1,
            },
            1024: {
              perPage: 1,
            },
            768: {
              perPage: 1,
              gap: '8px',
            },
            480: {
              perPage: 1,
              gap: '8px',
            },
            375: {
              perPage: 1,
              gap: '8px',
            },
          },
        }}
        hasTrack={false}
        style={{ padding: '0' }}
      >
        <SplideTrack>
          {images
            ? images.map(item => (
                <SplideSlide key={item.id}>
                  <Link
                    href={
                      id
                        ? `/product/${decodeBase64Id(id)}-${slug}`
                        : `/catalog/category/smartphones/xiaomi`
                    }
                    className={styles.slide}
                  >
                    <Image
                      className={styles.carouselImage}
                      src={item.url}
                      alt={'image-card'}
                      width={276}
                      height={238}
                      // layout={width <= 1240 ? 'responsive' : ''}
                      // placeholder="blur"
                    />
                  </Link>
                </SplideSlide>
              ))
            : splideData.map(item => (
                <SplideSlide key={item.id}>
                  <Link
                    href={`/catalog/category/smartphones/xiaomi`}
                    className={styles.slide}
                  >
                    <Image
                      className={styles.carouselImage}
                      src={item.image}
                      alt={'image-card'}
                      layout={width <= 1240 ? 'responsive' : ''}
                      placeholder="blur"
                    />
                  </Link>
                </SplideSlide>
              ))}
        </SplideTrack>
        <div className={styles.btnGroup}>
          <div className={styles.customPagination}>
            {images
              ? images.map((_, index) => {
                  return (
                    <div
                      className={`${styles.paginationDot} ${
                        currentSlide === index ? styles.active : ''
                      }`}
                      onClick={() => splide.go(index)}
                      key={index}
                      aria-label={`${currentSlide === index}`}
                    />
                  );
                })
              : splideData.map((_, index) => {
                  return (
                    <div
                      className={`${styles.paginationDot} ${
                        currentSlide === index ? styles.active : ''
                      }`}
                      onClick={() => splide.go(index)}
                      key={index}
                      aria-label={`${currentSlide === index}`}
                    />
                  );
                })}
          </div>
        </div>
      </Splide>
    </div>
  );
};

export default CustomCardCarousel;
